import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { useGetIndividualAvatarQuery } from "marketplace/individuals/_api/individual-api";
import { getIndividualAvatar } from "marketplace/individuals/_stores/individuals-redux-slice";
import Individual from "marketplace/individuals/individual";
import { useSelector } from "react-redux";

const StyledAvatar = styled(Avatar)<{ disabled?: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}));
const LoadingProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  height: "75%",
  width: "75%",
}));

type IndividualAvatarProps = {
  className?: string;
  individual?: Individual;
  disabled?: boolean;
};

export default function IndividualAvatar(props: Readonly<IndividualAvatarProps>) {
  const { className, individual, disabled } = props;

  const base64AvatarData = useSelector(getIndividualAvatar((individual?.profile.avatarId && individual.id) ?? null));
  const { isLoading: isLoadingAvatar } = useGetIndividualAvatarQuery(
    { individualId: individual?.id?.value ?? "" },
    { skip: !individual?.profile.avatarId || !!base64AvatarData || !individual?.id },
  );

  return (
    <>
      {(base64AvatarData) ? (
        <StyledAvatar 
          className={className}
          disabled={disabled}
          src={base64AvatarData}
        >
          {
            !base64AvatarData 
            && isLoadingAvatar
            && <LoadingProgress disableShrink />
          }
        </StyledAvatar>
      ) : (
        <Avatar className={className} />
      )}
    </>
  );
}
